export var SPACING_SCALE = {
  'sp-0': 0,
  'sp-25': 2,
  'sp-50': 4,
  'sp-75': 6,
  'sp-100': 8,
  'sp-150': 12,
  'sp-200': 16,
  'sp-300': 24,
  'sp-400': 32,
  'sp-500': 40,
  'sp-600': 48,
  'sp-800': 64
};